import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'

type FormStatusProps = Readonly<{
  kind: 'idle' | 'success' | 'error' | 'warning'
  title?: string
  description?: string
}>

export function FormStatus({ kind, title, description }: FormStatusProps) {
  if (kind === 'idle') return null

  const variant = kind === 'error' ? 'destructive' : 'default'

  return (
    <Alert variant={variant}>
      {title ? <AlertTitle>{title}</AlertTitle> : null}
      {description ? <AlertDescription>{description}</AlertDescription> : null}
    </Alert>
  )
}
